<template>
  <sgwg-content width="800" heigth="571">

    <v-snackbar v-model="snackbar" top absolute>Показания успешно переданы!</v-snackbar>

    <v-list-item two-line class="align-center">

      <sg-widget-icon height="48" width="48" class="mr-3" />

      <v-list-item-content>
        <v-list-item-title class="headline">Подача показаний</v-list-item-title>
        <v-list-item-subtitle>{{address}}</v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action>
        <v-btn icon @click.stop="close" large>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-list-item-action>

    </v-list-item>
    <sgwg-counters :counters="searchResult.meters" @save-readings="snackbar = true" />
  </sgwg-content>
</template>

<script>
  import SgwgCounters from './SgwgOneFormCounters'
  import SgwgContent from '@/components/SgwgContent'
  import SgWidgetIcon from '@/components/SgWidgetIcon'

  export default {
    components: {
      SgwgContent,
      SgwgCounters,
      SgWidgetIcon
    },
    props: {
      searchResult: Object,
    },
    computed: {
      address() {
        return this.searchResult.address
      },
    },
    data() {
      return {
        snackbar: false
      }
    },
    methods: {
      close() {
        this.$router.push({
          name: 'search'
        })
        this.postMessage('dialog:close')
      }
    }
  }
</script>

<style>

</style>